import { fetch } from 'utils/fetch'
import { endpoint } from '@library/endpoint'
import routes from 'config/routes'

const customersApi = {
  customerSignup,
}

export function customerSignup(accessToken, reqData) {
  const TIMEOUT = 50000

  return fetch(accessToken, `${endpoint('customers', 2)}${routes.customers.signup}`, reqData, 'POST', 'default', {}, TIMEOUT)
}

export const generateReference = () => (
  fetch(null, `${endpoint('core')}${routes.core.reference}`, {}, 'POST')
)

export default customersApi
